export default __webpack_public_path__ + "static/media/easyfmm_logo.38ce651b.png";